export enum InteractionType {
	Call = 0,
	Email = 1,
	Generic = 5,
	Voicemail = 6,
	WhatsApp = 7,
	Webchat = 8,
}
